import React from 'react';
import { connect } from 'react-redux';
import { CircularProgress } from '@material-ui/core';

import HeaderComponent from './HeaderComponent';
import { getTenantConfig, getUrlParams } from '../../config';

import renderMeetingInfoComponent from './MeetingInfoComponent';
import renderRegComponent from './RegFormComponent';
import renderNpiComponent from './NpiLookup';
import ContactLookupComponent from './NpiLookup/ContactLookupComponent';
import renderFooterComponent from './FooterComponent';
import { tenantUsesContactSpecificCodes } from '../../contactSpecificCode';

import { getMeetingInfo, getDropDownValues, setData } from '../../redux/dataSlice';

const { tenant, company } = getTenantConfig();

const RegForm = (props) => {
  // Alias the injected action creators so they don't shadow the module-level
  // imports of the same names (used in the connect() call below).
  const {
    dropDownValuesLoading,
    dropDownValuesLoaded,
    getDropDownValues: fetchDropDowns
  } = props;

  const regSource = getUrlParams('source');
  if (regSource && !props.regSource) {
    props.setData({ regSource });
  }

  React.useEffect(() => {
    if (!dropDownValuesLoading && !dropDownValuesLoaded) {
      fetchDropDowns();
    }
  }, [dropDownValuesLoading, dropDownValuesLoaded, fetchDropDowns]);

  const renderComponent = () => {
    if (!props.npiInfo) {
      if (!props.meetingInfo) {
        // The meeting decides which lookup to render, and MeetingInfoComponent is
        // still fetching it on a direct link or a refresh. Tenants that issue
        // contact-specific codes wait for it, because rendering the wrong lookup
        // lets the user set npiInfo and skip the flow the meeting requires.
        // Tenants that don't render immediately, exactly as before.
        if (tenantUsesContactSpecificCodes) {
          return <CircularProgress />;
        }
      } else if (props.meetingInfo.is_contact_specific) {
        // The meeting type is authoritative here, independent of tenant config:
        // identify the registrant from the `<meetingId>:<contactId>` code instead
        // of an NPI search. Flag off falls through to the standard flow below.
        // (A tenant with the flag set but no `additionalInviteCodeFormat` still
        // gets this screen; only the prefilled-URL shortcut needs the format.)
        return <ContactLookupComponent match={props.match} />;
      }
      // Forward `match` so tenant-specific NPI components can inspect the URL
      // invitecode.
      return renderNpiComponent(tenant, props.match);
    }
    return renderRegComponent(tenant);
  };

  return (
    <div className="registration-form-component">
      <HeaderComponent company={company} tenant={tenant} />
      <div className="registration-form-body">
        <div className="left-component">{renderComponent()}</div>
        <div className="right-component">{renderMeetingInfoComponent(tenant)}</div>
      </div>
      {renderFooterComponent(company, tenant, props.meetingInfo)}
    </div>
  );
};

const mapStateToProps = ({ data }) => {
  const { meetingInfo, npiInfo, dropDownValuesLoading, dropDownValuesLoaded } = data;
  return { meetingInfo, npiInfo, dropDownValuesLoading, dropDownValuesLoaded };
};

export default connect(mapStateToProps, {
  getMeetingInfo,
  getDropDownValues,
  setData
})(RegForm);
